import types from './types';
import { ThunkDispatch } from "redux-thunk";
import api from 'constants/api';
import _get from "lodash/get";

export const getExpired = (userId: string) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {

  dispatch({ type: types.GET_EXPIRED_AUTH_REQUEST });

  return api.authorization.expired.get(userId)
    .then((res: any) => {

      dispatch({
        type: types.GET_EXPIRED_AUTH_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Post failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.GET_EXPIRED_AUTH_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};
